export default "__VITE_PUBLIC_ASSET__7d30d094__"